/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AlertPageRequest} from '../models/AlertPageRequest';
import type {Error} from '../models/Error';
import type {GeneralAlertPage} from '../models/GeneralAlertPage';

export interface GetUserGeneralAlert$Request {
    userId: number;
    alertPageRequest: AlertPageRequest;
}

export interface GetUserGeneralAlert$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserGeneralAlertRequest = createAction<PayloadData<void, GetUserGeneralAlert$Request>>('USER_GENERAL_ALERT__GET_USER_GENERAL_ALERT__REQUEST');
export const getUserGeneralAlertSuccess = createAction<PayloadData<GeneralAlertPage, GetUserGeneralAlert$Request>>('USER_GENERAL_ALERT__GET_USER_GENERAL_ALERT__SUCCESS');
export const getUserGeneralAlertFailure = createAction<PayloadData<Error, GetUserGeneralAlert$Request, true>>('USER_GENERAL_ALERT__GET_USER_GENERAL_ALERT__FAILURE');

export const getUserGeneralAlertActions = [
    getUserGeneralAlertRequest,
    getUserGeneralAlertSuccess,
    getUserGeneralAlertFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {AlertPageRequest} meta.alertPageRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserGeneralAlert = (meta: GetUserGeneralAlert$Request, config?: GetUserGeneralAlert$Config) => {
    return {
        CALL_API: {
            types: getUserGeneralAlertActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/general/alerts`,
            TRANSPORT_REQUEST_BODY: meta.alertPageRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

